import { useTheme } from "@material-ui/core";
import { useEngineerCapacityByAggregator } from "capacity/useEngineerCapacityByAggregator";
import { PieChartCard } from "components/PieChartCard";
import useEngineersInAggregator from "engineers/useEngineersInAggregator";
import { EngineerAggregatorType } from "msd-capacity-planning-model";
import { useEffect, useState } from "react";
import useRegions from "regions/useRegions";
import { getColors } from "utils/colorGenerator";

export function SkillCapacityByRegionPieChart({
  year,
  month,
  skill,
}: {
  year: number;
  month: number;
  skill: string;
}) {
  const theme = useTheme();
  const regions = useRegions();
  const engineers = useEngineersInAggregator(
    year,
    month,
    EngineerAggregatorType.SKILL,
    skill
  );
  const capacities = useEngineerCapacityByAggregator(
    year,
    month,
    EngineerAggregatorType.REGION,
    engineers
  );
  const [data, setData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    const regionIds = Object.keys(capacities);
    const labels = regionIds.map((id) => regions[id]?.name || "");
    const data = regionIds.map(
      (id) => capacities[id]?.allocatedHours || 0
    );
    const backgroundColor = getColors(theme, data.length);
    setData({ labels, datasets: [{ data, backgroundColor }] });
  }, [theme, regions, capacities]);

  return <PieChartCard title="Skill capacity by region" data={data} />;
}
